import config from '@app/config';
import { useEffect, useState } from 'react';
import { ServiceCookies } from '@services/ServiceCookies';
import { ServiceEcommerce2 } from '@services/ServiceEcommerce';

const cookieName = 'ABC';

export enum variantsType {
  A = 'A',
  B = 'B',
  C = 'C',
}

/**
 * Хук для работы с A/B-тестированием фильтра на мобильных устройствах.
 *
 * Этот хук:
 * - Проверяет наличие cookie для A/B-теста мобильного фильтра.
 * - Если cookie нет, создаёт его с заданным значением.
 * - Возвращает текущее значение cookie.
 *
 * @returns {variantsType} - Текущее значение cookie.
 */
export const useAbTestMobileFilterCookie = (): variantsType | null => {
  const [currentVariant, setCurrentVariant] = useState<variantsType>(null);
  const createCookie = (): variantsType => {
    const variants: Array<variantsType> = [variantsType.A, variantsType.B, variantsType.C];
    const randomIndex = Math.floor(Math.random() * variants.length);
    const chosenVariant = variants[randomIndex];

    ServiceCookies.set(cookieName, chosenVariant, {
      domain: config.baseDomain,
      expires: ServiceCookies.getLifeTimeCookies(1),
    });

    return chosenVariant;
  };

  useEffect(() => {
    if (!currentVariant) {
      const cookieValue = ServiceCookies.get(cookieName) as variantsType | undefined;
      setCurrentVariant(cookieValue || createCookie());
      ServiceEcommerce2.abTestInitVariantAnalytics(cookieValue);
    }
  }, []);

  return currentVariant;
};
